import { Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { mapESentimentAnalysisSubcategoryToValue } from 'src/features/Enterprise/SentimentAnalysis/utils';

export type ReportItem = {
  category: number;
  subCategory: number;
  subCategoryDescription: string;
  isSubmitted: boolean;
  reportcount: number;
  uuids: string[];
};

export function getSubCategoriesColumns(): GridColDef<ReportItem>[] {
  return [
    {
      field: 'subCategory',
      headerName: 'Title',
      flex: 1,
      minWidth: 230,
      renderCell: ({ value }) => {
        return (
          <Tooltip title={mapESentimentAnalysisSubcategoryToValue(value)}>
            <Typography className="ellipsis" color="#3369E8">
              {mapESentimentAnalysisSubcategoryToValue(value)}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'subCategoryDescription',
      headerName: 'Description',
      flex: 3.5,
      minWidth: 300,
      renderCell: ({ value }) => (
        <Tooltip title={value}>
          <Typography className="ellipsis">{value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: 'reportcount',
      headerName: 'Report Count',
      sortable: false,
      flex: 0.5,
      minWidth: 120,
      renderCell: ({ value }) => (
        <Typography className="ellipsis">
          {value} report{+value > 1 ? 's' : ''}
        </Typography>
      ),
    },
  ];
}
